import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QueryPartInfoSearchByPartNumberDTO } from 'src/app/models/internal/query-partInfo-searchby-partnumber-dto';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { CopyProposalDTO } from 'src/app/models/internal/copy-proposal-dto';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { Constants } from 'src/app/core/constants';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from 'src/app/services/form';
import { DataService } from 'src/app/services/data.service';
import { ProposalService } from 'src/app/services/proposal.service';
import { of } from 'rxjs';
import { ProposalBasicInfoDTO } from 'src/app/models/internal/proposal-basicInfo-dto';
import { QueryPartProposalsSearchDTO } from 'src/app/models/internal/query-partproposals-search-dto';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { PackageType } from 'src/app/models/packagetype';
import { DatePipe } from '@angular/common';
import * as moment from 'moment/moment';
import Helper from 'src/app/core/utility/helper';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { PartInfo } from 'src/app/models/partinfo';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import UIHelper from 'src/app/core/utility/ui-helper';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


@Component({
    selector: 'app-search-part',
    templateUrl: './search-part.component.html',
    styleUrls: ['./search-part.component.scss']
})

export class SearchPartComponent extends BaseGridPage
    implements OnInit, AfterViewInit, ICanExportData {
    excelFilenamePrefix = "SearchPartResults_";
    searchPartForm: FormGroup;
    locStorage = Constants.localStorageKeys;
    partList: PartBasicInfo[];
    proposalList: ProposalBasicInfoDTO[];
    targetPartInfoIdList: PendingProposalPartInfo[];
    pipe = new DatePipe('en-US');
    
    getProposalClicked = false;
    partFound = false;
    // sourcePartInfoId: number;
    public formErrors = {
        PartNumber: '',
        SourceTypeId: '',
        PartCategoryId: '',
        PackageTypeId: '',
        DemandDate: '',
        DueDate: '',
        Demand_Status: '',
        WorkflowStatusId: '',
        TeslaEquipmentCode: ''
    };
    filterForm: FormGroup;
    newStatus: number = Constants.WORKFLOW_STATUS_NEW;
    submittedStatus: number = Constants.WORKFLOW_STATUS_SUBMITTED;
    atLeastOneFieldError: boolean = false;
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    packageTypeList:  PackageType[];
    autoCompletePEURL: string;
    childControlTooltipText: string = '';
    Demand_Status = [{ text: 'Past', value: 'P' }, { text: 'Future', value: 'F' }, { text: 'Current', value: 'C' }, { text: 'No Demand', value: 'N' }];
    WorkflowStatusId = [{ text: 'New', value: 1 }, { text: 'Submitted', value: 2 }, { text: 'Approved', value: 4 }, { text: 'Rejected', value: 3 }];

    constructor(
        localstorageService: LocalstorageService,
        private toastService: ToastService,
        private readonly route: ActivatedRoute,
        private router: Router,
        private FormService: FormService,
        private dataService: DataService,
        private fb: FormBuilder,
        logger: NGXLogger,
        appSettings: AppSettings,
        private proposalService: ProposalService
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            PartNumber: [null],
            SourceTypeId: [null],
            PartCategoryId: [null],
            PackageTypeId: [null],
            Demand_Status: [null],
            TeslaEquipmentCode: [null],
            WorkflowStatusId: [null]
        });
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
    }

    ngOnInit() {
        this.getSourceTypes();
        this.getPartSystems();
        this.getPackageTypes();
        this.initFilterValues();
    }

    getPartNumberToSearch() {
        let partNumber: string = this.searchPartForm.controls[
            'partNumberToSearch'
        ].value;
        if (partNumber) {
            partNumber = partNumber.trim();
        }
        return partNumber;
    }

    fillGrid(): void {
        this.partList = [];
        this.targetPartInfoIdList = [];
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.getProposalClicked = false;
        this.getParts();
    }

    exportData()
    {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        const queryPartInfoSearchByPartNumberDTO: QueryPartInfoSearchByPartNumberDTO = new QueryPartInfoSearchByPartNumberDTO();
        queryPartInfoSearchByPartNumberDTO.SearchFilter = this.filter;
        queryPartInfoSearchByPartNumberDTO.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode),

        this.dataService      
        .getAllPartsForSupplierExcel(queryPartInfoSearchByPartNumberDTO)
        .subscribe((response: any) => {
            if (response != null && response.Success) {
                UIHelper.DownloadExcelFile(response.Data, filename);
            } else {
                this.toastService.error(
                    'Could not export data'
                );
            }
        });
    }

    UpdateFilter()
    {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, "PartNumber", Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        /**
         * TMS-16564 Part Search Enhancement
         * Search Part (Supplier): Implement filters of SourceTypeId, PartCategoryId
         */
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        // TMS-18490 Add 'Package Type' Filter in Supplier and PE 'Search Part' Screen
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'Demand_Status', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'TeslaEquipmentCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'WorkflowStatusId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }

    clearFilter()
    {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
        this.proposalList = [];
        this.targetPartInfoIdList = [];
        this.search();
    }

    getParts() {
      this.UpdateFilter();
      const queryPartInfoSearchByPartNumberDTO: QueryPartInfoSearchByPartNumberDTO = new QueryPartInfoSearchByPartNumberDTO();
      queryPartInfoSearchByPartNumberDTO.SearchFilter = this.filter;
      queryPartInfoSearchByPartNumberDTO.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode),

      this.dataService
          .getAllPartsForSupplier(queryPartInfoSearchByPartNumberDTO)
          .subscribe((response: any) => {
              //this.partInfo = response
              if (response != null ) {
                  this.partList = response.Data;
                  this.gridView = of({
                      data: response.Data,
                      total: response.Total ? response.Total : 0,
                  });
              } else {
                  this.toastService.error('Part not found', true);
              }
          });
    }

    /**
     * TMS-16564 Part Search Enhancement
     * Add source type id filter
     */
    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data) {
                this.sourceTypeList = response.Data;
            }
        });
    }

    /**
     * TMS-16564 Part Search Enhancement
     * Add part system filter
     */
    getPartSystems() {
        this.dataService.getPartSystems().subscribe((response: any) => {
            if (response && response.Success) {
                this.partSystemList = response.Data;
            }
        });
    }

    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            if (response && response.Success) {
                this.packageTypeList = response.Data;
            }
        })
    }

    SearchProposals(partInfo: PartBasicInfo) {
        if (!partInfo) {
            return;
        }
        // if(!this.sourcePartInfoId)
        // {
        //   this.sourcePartInfoId = partInfoId;
        // }
        this.getProposalClicked = true;
        const queryPartProposalsSearchDTO: QueryPartProposalsSearchDTO = new QueryPartProposalsSearchDTO();
        queryPartProposalsSearchDTO.Id = partInfo.Id;
        queryPartProposalsSearchDTO.PEId = 0;
        queryPartProposalsSearchDTO.PartNumber = partInfo.PartNumber;
        queryPartProposalsSearchDTO.SupplierCode = partInfo.SupplierCode;
        queryPartProposalsSearchDTO.UOMCode = partInfo.POUomCode;
        queryPartProposalsSearchDTO.SourceTypeId = partInfo.SourceTypeId;
        const workflowStatusId = this.filterForm.get("WorkflowStatusId").value;        
        queryPartProposalsSearchDTO.WorkflowStatusId = workflowStatusId;
        const teslaEquipmentCode = this.filterForm.get("TeslaEquipmentCode").value;        
        queryPartProposalsSearchDTO.TeslaEquipmentCode = teslaEquipmentCode;

        this.dataService
            .getProposalsForPart(queryPartProposalsSearchDTO)
            .subscribe((response: any) => {
                // this.partInfo = response
                this.scrollToBottom();
                if (response) {
                    this.proposalList = response.Data;
                    Helper.getCSSClassForProposalList(this.proposalList);
                }
            });
    }

    initiateState() {
        this.getProposalClicked = false;
        this.partList = [];
        this.proposalList = [];
        this.targetPartInfoIdList = [];
    }
    
    viewProposal(id: number) {
        this.proposalService.RefreshproposalToViewId(id);
        window.open('viewproposal/' + id, '_blank');
    }

    navigateToUpdateProposal(id: number) {
        // this.router.navigate(['/proposal', id] );
        window.location.href = '/proposal/' + id;
    }

    getEffectivityFrom(dataItem: any) {
        if (dataItem) {
            //const effectivityFrom = this.pipe.transform(dataItem.EffectiveFrom, 'short');
            return Helper.formatDate(dataItem.EffectiveFrom);
        } else {
            return '';
        }
    }

    getEffectiveTo(unformattedDate: Date) {
            return Helper.getEffectiveTo(unformattedDate);
    }

    /*
    TMS-12409 Check with proposal exists with New/submitted/rejected status while
    creating proposal for any part can return a message showing proposal already 
    exists for search-part screen for any supplier logged in 
    
    Update:
    TMS-14551 Criteria for determining existing proposal
    Remove exising proposal check
    */
    createProposal(part: PartBasicInfo) {
        const selectedParts: PartBasicInfo[] = [];
        selectedParts.push(part);
        this.proposalService.RefreshpartInfoToBeCreatedList(selectedParts);
        this.router.navigate(['../', 'proposal']);
    }

    getProposalStatus(statusId: number)
    {
        return Helper.getProposalStatusDescription(statusId);
    }

    setSourceTypeDesc(dataItem: PartInfo) {
        return  Helper.getSourceTypeToDisplay(dataItem);
    }

    checkToCopyFromExistingProposal (proposal: ProposalBasicInfoDTO) {
        return proposal != null && proposal.WorkflowStatusId == Constants.WORKFLOW_STATUS_APPROVED;
    }

    addDaysToDate(date: Date, days: number){
        var res = new Date(date);
        res.setDate(res.getDate() + days);
        return res;
    }

    copyProposal(proposalBasicInfoDTO: ProposalBasicInfoDTO) {
        if (!this.checkToCopyFromExistingProposal(proposalBasicInfoDTO)) {
            return;
        }
        this.targetPartInfoIdList.push( this.convertProposalBasicInfoDTOToPendingProposalPartInfo(proposalBasicInfoDTO));
        const copyProposalDTO: CopyProposalDTO = {
            Id: 0,
            Enabled: true,
            IsSelected: true,
            SourceProposalId: proposalBasicInfoDTO.Id,
            SourcePartInfoId: proposalBasicInfoDTO.PartInfoId,
            TargetPartInfoIdList: this.targetPartInfoIdList,
            isForSupplier: true,
            isTeslaCreated: false,
            EffectiveFrom: this.addDaysToDate(new Date(), 7), 
        };
        this.logger.debug('copying prop with dto' + copyProposalDTO);
        this.dataService.copyProposal(copyProposalDTO)
            .subscribe((response: any) => {                
                if (response != null) {
                    this.proposalService.RefreshsavedproposalIds(response.Data);
                    this.toastService.success('Proposal(s) copied to create the following records', true);
                    this.navigateToSavedProposals();
                } else {
                    this.toastService.error(
                        'Could not copy the proposal'
                    );
                }
            });
        this.targetPartInfoIdList = [];
    }

    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }

    // convert ProposalBasicInfoDTO to PendingProposalPartInfo
    convertProposalBasicInfoDTOToPendingProposalPartInfo(proposalBasicInfoDTO: ProposalBasicInfoDTO) {
       if (proposalBasicInfoDTO == null) {
           return null;
       }
       var pendingProposalPartInfo = new PendingProposalPartInfo();

       pendingProposalPartInfo.ProposalId = 0;
       pendingProposalPartInfo.Note = proposalBasicInfoDTO.Note;
       pendingProposalPartInfo.PartNumber = proposalBasicInfoDTO.PartNumber;
       pendingProposalPartInfo.SupplierName = proposalBasicInfoDTO.SupplierName;
       pendingProposalPartInfo.PartDescription = proposalBasicInfoDTO.PartDescription;
       pendingProposalPartInfo.SupplierCode = proposalBasicInfoDTO.SupplierCode;
       pendingProposalPartInfo.SourceTypeId = proposalBasicInfoDTO.SourceTypeId;
       pendingProposalPartInfo.SourceTypeDescription = proposalBasicInfoDTO.SourceTypeDescription;
       pendingProposalPartInfo.POUomCode = proposalBasicInfoDTO.POUomCode;
       pendingProposalPartInfo.Length = proposalBasicInfoDTO.Length;
       pendingProposalPartInfo.Width = proposalBasicInfoDTO.Width;
       pendingProposalPartInfo.Height = proposalBasicInfoDTO.Height;
       pendingProposalPartInfo.Weight = proposalBasicInfoDTO.Weight;
       pendingProposalPartInfo.Id = proposalBasicInfoDTO.Id;
       pendingProposalPartInfo.Enabled = proposalBasicInfoDTO.Enabled;
       pendingProposalPartInfo.IsSelected = proposalBasicInfoDTO.IsSelected;

       return pendingProposalPartInfo;
    }

    deleteProposal(proposal) {
        if (Helper.confirmDeleteAction()) {
            this.dataService.deleteProposal(proposal.Id).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('Proposal deleted successfully', true);
                    this.SearchProposals(proposal);
                } else {
                    this.toastService.error(
                        'Could not delete the proposal'
                    );
                }
            });
        } else {
        this.toastService.info('You cancelled the delete request');
        }
    }

    navigateToSavedProposals() {
        this.router.navigate(['/saved-proposals'] );
    }

    hasUserEnterAnyValue() {
        const controls = this.filterForm.controls;        
        if (!controls) return true;

        const anyFieldHasValue = Object.keys(controls).some(key => controls[key].value);
        return anyFieldHasValue;
    }

    localSearch() {
        this.atLeastOneFieldError = false;
        if(!this.hasUserEnterAnyValue()) {
            this.atLeastOneFieldError = true; 
            return;
        }

        this.search();
    }

    //TMS-19213 Get PackageTypeDescription to display on table 
    getPackageType(packageTypeId) {
        return Helper.getPackageTypeDescription(packageTypeId);
    }
}
